import React, { useContext, useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

const { Item, SubMenu } = Menu;

import CurrentUserContext from 'contexts/CurrentUserContext';
import { isDevEnvironment } from 'utils/environment';
import options from './options';

const Sidebar = () => {
  const { hasPermission } = useContext(CurrentUserContext);
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  const selectedKey = `/${location.pathname.split('/')[1]}`;

  const subMenu = useMemo(() => {
    return options.reduce((prev, { nameId, subMenu }) => {
      if (subMenu) {
        return [...prev, {
          nameId,
          subMenu: subMenu.map(({ path }) => path),
        }];
      }
      return prev;
    }, []);
  }, []);

  useEffect(() => {
    const matching = subMenu.find(({ subMenu: paths }) => paths.includes(selectedKey));
    if (matching) {
      setOpenKeys([matching.nameId]);
    }
  }, [selectedKey, subMenu]);

  const renderItem = ({ subMenu, permissions, path, nameId, icon, hidden, devOnly }) => {
    if (hidden || (devOnly && !isDevEnvironment())) {
      return null;
    }
    if (permissions && !hasPermission(permissions)) {
      return null;
    }
    if (subMenu) {
      return <SubMenu key={nameId} icon={icon} title={<FormattedMessage id={nameId} />}>
        {subMenu.map(renderItem)}
      </SubMenu>;
    }
    return (
      <Item key={path} icon={icon}>
        <NavLink to={path}>
          <FormattedMessage id={nameId} />
        </NavLink>
      </Item>
    );
  };
  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[selectedKey]}
      openKeys={openKeys}
      onOpenChange={setOpenKeys}
    >
      {options.map(renderItem)}
    </Menu>
  );
};

export default Sidebar;
